export function OutlineLightbulbIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1536 13.6002C16.7534 12.5156 17.5116 12.1509 17.9051 10.86C18.0779 10.2986 18.1691 9.70353 18.1691 9.08448C18.1691 5.49496 15.0594 2.63486 11.3931 3.03797C8.58103 3.35469 6.32079 5.64373 6.03286 8.45104C5.94648 9.29563 6.03286 10.1114 6.2632 10.86C6.6519 12.1269 7.43411 12.4101 8.05796 13.6386C8.36029 14.2384 8.701 15.1742 8.7058 16.5227H15.4529C15.4625 15.1502 15.8177 14.2144 16.1584 13.6002H16.1536Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0837 15.9896V9.36719"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.72013 16.5522V18.7549C8.72013 19.993 9.72309 21.0007 10.966 21.0007H13.2022C14.4403 21.0007 15.4481 19.9978 15.4481 18.7549V16.5618C15.4481 16.5618 15.4481 16.5378 15.4481 16.5234H8.71533C8.71533 16.5234 8.71533 16.5426 8.71533 16.5522H8.72013Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
